import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import React, { useState, useEffect } from 'react'

import styles from './ExpandableWidget.module.sass'

const ExpandableWidget = (props) => {
	const {
		className,
		expanded: propsExpanded,
		heading: Heading = 'h3',
		titleAppearance,
		arrowPosition,
		expandable = true,
		icon,
		title,
		collapsedLabel,
		expandedLabel,
		children,
		margins,
		moreContent,
		moreContentTitle,
		lessContentTitle,
		...attributes
	} = props
	const [expanded, setExpanded] = useState(propsExpanded)
	const [moreContentVisible, setMoreContentVisible] = useState(false)
	useEffect(() => {
		setExpanded(propsExpanded)
	}, [propsExpanded])
	return (
		<Widget
			margins={margins}
			className={`${styles['root'] || ''} ${
				styles[titleAppearance] || ''
			} ${className || ''}`}
		>
			<div
				className={`${styles['title-container']} ${
					!expanded ? styles['is-collapsed'] : ''
				} ${styles[`arrow-position-${arrowPosition}`] || ''}`}
				disabled={!expandable}
				onClick={() => {
					expandable && setExpanded(!expanded)
				}}
			>
				<Icon
					className={styles['arrow']}
					width='24px'
					height='24px'
					name='expanded-arrow'
				/>
				<HStack gap='xsmall' justify='space-between' align='center'>
					<Heading className={`${styles['title']}`}>
						{icon && (
							<Icon
								className={styles['icon']}
								width='20px'
								height='20px'
								name={icon}
							/>
						)}
						<span>{title}</span>
					</Heading>
					{!expanded && collapsedLabel ? (
						<small className={styles['label']}>
							{collapsedLabel}
						</small>
					) : expanded && expandedLabel ? (
						<small className={styles['label']}>
							{expandedLabel}
						</small>
					) : null}
				</HStack>
			</div>
			{expanded && (
				<Widget className={styles['content']} {...attributes}>
					{children}
					{moreContent && (
						<ActionButton
							className={styles['align-center']}
							secondary
							onClick={() => {
								setMoreContentVisible((prev) => {
									return !prev
								})
							}}
						>
							{moreContentVisible
								? lessContentTitle
								: moreContentTitle}
						</ActionButton>
					)}
					{moreContentVisible && moreContent}
				</Widget>
			)}
		</Widget>
	)
}

export default ExpandableWidget
